import { useState } from "react";
import { faqs } from "@/mocks/siteContent";
import SectionHeading from "./SectionHeading";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  return (
    <section id="faq" className="w-full bg-background-50 px-4 py-14 md:px-8 md:py-20">
      <div className="mx-auto max-w-4xl">
        <SectionHeading
          align="center"
          eyebrow="常见问题"
          title="关于伦理片在线观看，你可能想先知道这些"
          desc="下面整理了观众最常问的几个问题，涉及题材定义、榜单排序、入门选片与移动端浏览。点击任意问题即可展开完整回答。"
        />

        <dl className="mt-10 divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
          {faqs.map((faq, index) => {
            const isOpen = openId === faq.id;
            return (
              <div key={faq.id}>
                <dt>
                  <button
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => setOpenId(isOpen ? null : faq.id)}
                    className="flex w-full items-center gap-4 px-5 py-5 text-left md:px-6"
                  >
                    <span className="font-label text-xs text-primary-600">{String(index + 1).padStart(2, "0")}</span>
                    <span className="flex-1 font-heading text-base text-foreground-950">{faq.question}</span>
                    <i
                      className={`ri-add-line shrink-0 text-xl text-foreground-500 transition-transform duration-300 ${
                        isOpen ? "rotate-45" : ""
                      }`}
                    ></i>
                  </button>
                </dt>
                <dd
                  className={`grid transition-all duration-300 ease-out ${
                    isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 pl-11 text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-12">
                      {faq.answer}
                    </p>
                  </div>
                </dd>
              </div>
            );
          })}
        </dl>
      </div>
    </section>
  );
}